// extracted by mini-css-extract-plugin
export default {"wrapper":"Uo","centered":"Vo","gridWrapper":"Wo","grid":"Xo","oneColumn":"Yo","marginLeftAuto":"Zo"};